import React from "react";
import { Grid } from "@material-ui/core";
import SimpleDialogDemo from "../../../Modals/SimpleDialog";
import InventoryItemForm from "./InventoryItemForm";

export default function CreateInventoryItem() {
  return (
    <Grid container direction="column" alignItems="center">
      <Grid item xs={12}>
        <SimpleDialogDemo buttonText={"Crear item de inventario"} fullScreen={true}>
          <InventoryItemForm />
        </SimpleDialogDemo>
      </Grid>
    </Grid>
  );
}
